module.exports = __webpack_public_path__ + "static/28-thumb-ea0032fdbb605d1ea0ce3bc70e9548f2.jpg";